export default __webpack_public_path__ + "static/media/IMG_9937.afe56376.jpg";